import React from "react";
import { Link } from "react-router-dom";

const ButtonList = ({
  items,
  screen,
  layout = "vertical",
  onVideoClick = () => {},
  activeClickIndex = null,
  imageUrls = [],
}) => {
  if (screen === "idle" && layout === "grid") {
    return (
      <div className="video-grid">
        {items.map((item, index) => (
          <div 
            className={`grid-item position-${index + 1}`} 
            key={index}
            style={{
              transform: activeClickIndex === index ? 'scale(95%)' : 'scale(100%)',
              transition: 'transform 0.25s ease'
            }}
          >
            <div className="isuzu-btn-container">
              <Link
                className="text-decoration-none isuzu-btn isuzu-btn-shape"
                onClick={() => onVideoClick(index)}
                style={{
                  fontFamily: "'Shorai Sans', sans-serif",
                }}>
              
                {imageUrls[index] && (
                  <img 
                    src={`${process.env.PUBLIC_URL}/${imageUrls[index]}`} 
                    alt="Feature icon" 
                    className="feature-icon" 
                    style={{
                      width: "50px",
                      height: "50px",
                      margin: "0px",
                      verticalAlign: "center"
                    }}
                  />
                )}
                <span>{item}</span>
              </Link>
            </div>
          </div>
        ))}
      </div>
    );
  }
  
  return <></>;
};

export default ButtonList;